// extracted by mini-css-extract-plugin
export var readonly = "_gx-1";
export var star = "_gx-0";